import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import 'react-spring-bottom-sheet/dist/style.css'
import "./styles/css/main.scss";
if (process.env.REACT_APP_ENV === "demo") {
    const { mock } = require("./mocks/browser");
    mock.start();
}
const container = document.getElementById('root');
const root = createRoot(container);

root.render(<BrowserRouter><App/></BrowserRouter>);

// serviceWorkerRegistration.unregister();
// ReactDOM.render(
//     // <BrowserRouter basename={"/shop"}>
//     <BrowserRouter>
//         <App/>
//     </BrowserRouter>,
//     document.getElementById("root")
// );
document.getElementById("root").classList.add('rtl');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

if (process.env.REACT_APP_ENV !== "demo") serviceWorkerRegistration.register();